module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/incense@3x_3d674f.jpg";